import React, { FunctionComponent } from 'react';

import ReactHTMLParser from 'html-react-parser';
import { Button, Modal } from 'react-bootstrap';

interface Props {
    title: string;
    body: string;
    confirmButtonLabel: string;
    cancelButtonLabel?: string;
    size?: 'sm' | 'lg' | 'xl';
    cancel?: () => void;
    confirm: () => void;
}

export const ConfirmModal: FunctionComponent<Props> = ({
    title,
    body,
    confirmButtonLabel,
    cancelButtonLabel,
    size = 'sm',
    cancel,
    confirm,
}) => {
    return (
        <Modal show onHide={(): void => cancel?.()} size={size} className="r4e-confirm-modal" centered>
            <Modal.Header closeButton={!!cancel}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <div>{ReactHTMLParser(body)}</div>
            </Modal.Body>
            <Modal.Footer>
                {cancelButtonLabel && cancel && (
                    <Button variant="link" className="btn-link" onClick={(): void => cancel()}>
                        {cancelButtonLabel}
                    </Button>
                )}
                <Button
                    variant="primary"
                    onClick={(): void => {
                        confirm();
                    }}
                >
                    {confirmButtonLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
